import '../social_content_previous_comments_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.TwitterContentPreviousCommentsView extends Monitoring.Views.SocialContentPreviousCommentsView

  initialize: (@options = {}) ->
    super(@options)
    @modelContentId = @socialContent.tweet_id()

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @searchQuery.addContentId(@modelContentId)
    @searchQuery.addContextKind('tw_previous_comments')
    @addContextLimit()
    dateTo = Date.create(@socialContent.created_at()).getTime()
    dateFrom = dateTo - (1000 * 60 * 60 * 24 * 365 * 2) # 2 years ago. The ideal would be the created_at of the parent post
    @searchQuery.addDateTo(dateTo)
    @searchQuery.addDateFrom(dateFrom)
    @searchQuery.setNowDate(false)